// import logo from './logo.svg';
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { ToastContainer } from 'react-toastify';
import Nav from './components/Nav';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AddArticle from './components/AddArticle';
import Articleshow from './components/Articleshow';
import Ordershow from './components/Ordershow.js';
import Addorder from './components/Addorder';
import UpdateOrder from './components/UpdateOrder';
import UpdateArticle from './components/UpdateArticle';
import Dashboard from './components/Dashboard';
import Reports from './components/Reports';
import Customers from './components/Customers';
import ExpenseManager from './components/ExpenseManager.js';
import ExpenseDashboard from './components/ExpenseDashboard';
import AddCustomer from './components/AddCustomer.js';
import InventoryComponent from './components/InventoryComponent.js'; // New Import
import CrystalDashboard from './components/CrystelDashboard.js';
import ManageWebsite from './components/ManageWebsite';
import { GLOBAL_CALCULATIONS } from './components/GlobalLogic';

// --- AUTHENTICATION IMPORTS ---
import Login from './components/Login'; 
import ProtectedRoute from './components/ProtectedRoute'; 
import EditCustomer from './components/EditCustomer.js';

function App() {
  useEffect(() => {
    GLOBAL_CALCULATIONS.initializeData();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Routes>
          {/* PUBLIC ROUTE */}
          <Route path="/login" element={<Login />} />

          {/* PROTECTED ROUTES */}
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />

          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />

          <Route path="/crystaldashboard" element={
            <ProtectedRoute>
              <CrystalDashboard />
            </ProtectedRoute>
          } />

          <Route path="/addarticle" element={
            <ProtectedRoute>
              <AddArticle />
            </ProtectedRoute>
          } />

          <Route path="/articles" element={
            <ProtectedRoute>
              <Articleshow />
            </ProtectedRoute>
          } />

          <Route path="/addorder" element={
            <ProtectedRoute>
              <Addorder />
            </ProtectedRoute>
          } />

          <Route path="/orders" element={
            <ProtectedRoute>
              <Ordershow />
            </ProtectedRoute>
          } />

          <Route path="/update-order/:id" element={
            <ProtectedRoute>
              <UpdateOrder />
            </ProtectedRoute>
          } />

          <Route path="/update-article/:id" element={
            <ProtectedRoute>
              <UpdateArticle />
            </ProtectedRoute>
          } />

          <Route path="/customers" element={
            <ProtectedRoute>
              <Customers />
            </ProtectedRoute>
          } />

          {/* NEW INVENTORY ROUTE */}
          <Route path="/inventory" element={
            <ProtectedRoute>
              <InventoryComponent />
            </ProtectedRoute>
          } />

          <Route path="/expense-manager" element={
            <ProtectedRoute>
              <ExpenseManager />
            </ProtectedRoute>
          } />

          <Route path="/expenses" element={
            <ProtectedRoute>
              <ExpenseDashboard />
            </ProtectedRoute>
          } />

          <Route path="/add-customer" element={
            <ProtectedRoute>
              <AddCustomer />
            </ProtectedRoute>
          } />

          {/* FIXED: Added /:id parameter to allow dynamic editing */}
          <Route path="/edit-customer/:id" element={
            <ProtectedRoute>
              <EditCustomer />
            </ProtectedRoute>
          } />

          <Route path="/reports" element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          } />
          <Route path="/manage-website" element={
            <ProtectedRoute>
              <ManageWebsite />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
}

export default App;